<template>
<button type="button" class="odr-toggle__trigger" @click="handleClick">
    <slot></slot>
</button>
</template>
<script>
import { getParentToggleStore } from './toggle'

export default {
    props: {
        keepOpenedRest: {
            _descr: 'hide rest toggle-content when specific was opened',
        },
        name: {
            type: String,
            _descr: 'name of specific toggle-content to be shown/hided',
        },
    },
    data () {
        return {
            store: null,
            eName: this.name || null,
            eKeepOpenedRest: !!this.keepOpenedRest,
        }
    },
    mounted () {
        let parent = getParentToggleStore(this.$parent)
        this.store = parent.store
        this.eName = this.eName || parent.defaultName
        this.eKeepOpenedRest = this.keepOpenedRest === undefined ? parent.keepOpenedRest : this.keepOpenedRest
    },
    methods: {
        handleClick () {
            if (!this.eKeepOpenedRest) {
                Object.keys(this.store).forEach(name => {
                    if (name !== this.eName) {
                        this.store[name] = false
                    }
                })
            }

            this.store[this.eName] = !this.store[this.eName]

            if (window.__odrBus) {
                window.__odrBus.$emit('possible-resize')
            }

            this.$emit('onclick', !!this.store[this.eName])
        },
    },
}
</script>
